import { createSlice } from "@reduxjs/toolkit"

interface FinanceFormValue {
    search_key: string
    child_status_ids: any[]
    assigned_to: Record<string, any>
    country_ids: any[]
    zone_ids: any[]
    region_ids: any[]
    state_ids: any[]
    city_ids: any[]
    site_ids: any[]
    raised_on_from: string
    raised_on_to: string
    age: any[]
    age_op: string
    less_than_age: string
    between_age1: string
    between_age2: string
    more_than_age: string
    payment_status: any[]
    due_date_start: string
    due_date_end: string
    tag_ids: any[]
    category_ids: any[]
    on_hold: string
    on_hold_reason_ids: any[]
    on_hold_date: string
    product_ids: any[]
    parent_status: string
    siteIds: any[]
    account_id: number[]
    parent_account_id: number[]
    ecom_order_id: string
}

interface InitialState {
    page: number
    selectedValue: number
    selectedMetricKey: string
    chargerDisplayValues: any
    chargerCurrentRules: any
    StateDisplayValues: any
    StateCurrentRules: any
    CityDisplayValues: any
    CityCurrentRules: any
    currentRules: any
    displayValues: any
    FinanceFormValue: FinanceFormValue
    FinanceDealTab: number
    selectedTab: number
    ticketId: string
    selectStatus: any
    dealType: string
    sitesDisplayValues: any[]
    sitesCurrentRules: any[]
    tableFetch :boolean
    visibleColumns: {
        name: string
        visible: boolean
    }[]
}

const initialState: InitialState = {
    page: 1,
    selectedValue: 10,
    selectedMetricKey: "",
    chargerDisplayValues: [],
    chargerCurrentRules: [],
    StateDisplayValues: [],
    StateCurrentRules: [],
    CityDisplayValues: [],
    CityCurrentRules: [],
    currentRules: [],
    displayValues: [],
    ticketId: "",
    FinanceFormValue: {
        search_key: "",
        child_status_ids: [],
        assigned_to: {},
        country_ids: [],
        zone_ids: [],
        region_ids: [],
        state_ids: [],
        city_ids: [],
        site_ids: [],
        raised_on_from: "",
        raised_on_to: "",
        age: [],
        age_op: "",
        less_than_age: "",
        between_age1: "",
        between_age2: "",
        more_than_age: "",
        payment_status: [],
        due_date_start: "",
        due_date_end: "",
        tag_ids: [],
        category_ids: [],
        on_hold: "",
        on_hold_reason_ids: [],
        on_hold_date: "",
        product_ids: [],
        parent_status: "all_tab",
        siteIds: [],
        account_id: [],
        parent_account_id: [],
        ecom_order_id: "",
    },
    FinanceDealTab: 0,
    selectedTab: 0,
    selectStatus: {},
    dealType: "",
    sitesDisplayValues: [],
    sitesCurrentRules: [],
    tableFetch:false,
    visibleColumns: [{ name: "Ecom Order ID", visible: false }],
}

const FinanceSlice = createSlice({
    name: "Finance",
    initialState,
    reducers: {
        setFinanceForm: (state, payload) => {
            state.FinanceFormValue = payload?.payload
        },
        setDisplayValues: (state, payload) => {
            state.displayValues = payload?.payload
        },
        setCurrentRuleValue: (state, payload) => {
            state.currentRules = payload?.payload
        },
        setChargerDisplayValues: (state, payload) => {
            state.chargerDisplayValues = payload?.payload
        },
        setChargerCurrentRuleValue: (state, payload) => {
            state.chargerCurrentRules = payload?.payload
        },
        setCityDisplayValues: (state, payload) => {
            state.CityDisplayValues = payload?.payload
        },
        setCityCurrentRuleValue: (state, payload) => {
            state.CityCurrentRules = payload?.payload
        },
        setStateDisplayValues: (state, payload) => {
            state.StateDisplayValues = payload?.payload
        },
        setStateCurrentRuleValue: (state, payload) => {
            state.StateCurrentRules = payload?.payload
        },
        setPages: (state, payload) => {
            state.page = payload?.payload
        },
        setSelectedValues: (state, payload) => {
            state.selectedValue = payload?.payload
        },
        setDealTab: (state, payload) => {
            state.FinanceDealTab = payload?.payload
        },
        setSelectedTab: (state, payload) => {
            state.selectedTab = payload?.payload
        },
        setTicketId: (state, payload) => {
            state.ticketId = payload?.payload
        },
        setSelectStatus: (state, payload) => {
            state.selectStatus = payload?.payload
        },
        setDealType: (state, payload) => {
            state.dealType = payload?.payload
        },
        setSitesDisplayValues: (state, action) => {
            state.sitesDisplayValues = action?.payload
        },
        setSitesCurrentRuleValue: (state, action) => {
            state.sitesCurrentRules = action?.payload
        },
        setTableFetchValue: (state, action) => {
            state.tableFetch = action?.payload
        },
        setVisibleColumns: (state, action) => {
            state.visibleColumns = action?.payload
        },
        setSelectedMetricKey: (state, action) => {
            state.selectedMetricKey = action?.payload
        },
    },
})

export const {
    setDisplayValues,
    setChargerCurrentRuleValue,
    setChargerDisplayValues,
    setCurrentRuleValue,
    setFinanceForm,
    setCityCurrentRuleValue,
    setCityDisplayValues,
    setStateCurrentRuleValue,
    setStateDisplayValues,
    setPages,
    setSelectedValues,
    setSelectedTab,
    setDealTab,
    setTicketId,
    setSelectStatus,
    setDealType,
    setSitesCurrentRuleValue,
    setSitesDisplayValues,
    setTableFetchValue,
    setVisibleColumns,
    setSelectedMetricKey,
} = FinanceSlice.actions
export const getAllUser = (state: any) => state.users.loading
export const addUserSuccess = (state: any) => state.users.addSuccess

export default FinanceSlice.reducer
